//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import viewportMixin from '@/mixins/viewport.mixin';
import Chat from './chat.vue';
import Banner from './banner.vue';

export default {
  components: { Chat, Banner },
  mixins: [viewportMixin],
  computed: {
    display: {
      get() {
        return this.$store.state.event.displayMobileView;
      },
      set(payload) {
        this.$store.commit('event/SET_DISPLAY_MOBILE_VIEW', payload);
      },
    },
  },
  watch: {
    isMobile(payload) {
      if (!payload) this.display = false;
    },
    display(value) {
      if (!process.browser) return;

      const html = document.documentElement;

      if (value) {
        html.classList.add('overflow-y-hidden');
      } else {
        html.classList.remove('overflow-y-hidden');
      }
    },
  },
};
